import React from 'react'
import PropTypes from 'prop-types';

import Head from 'next/head';
import { markupJson, isAbsoluteURL } from '@app/helpers';


function OrganisationJsonLd({
  name, 
  description,
  url,
  website,
  email,
  logo
}) {

  const jsonData= {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": name,
    "description": description,
    "logo": logo,
    "email": email,
    "url": url,
    "sameAs": isAbsoluteURL(website) ? website : `http://${website}`
  };


  return (
    <Head>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={markupJson(jsonData)}
        key="jsonld-event"
      />
    </Head>
  );
}

OrganisationJsonLd.propTypes = {
  name: PropTypes.string.isRequired, 
  description: PropTypes.string.isRequired,
  website: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired
};


export default OrganisationJsonLd;
